import { createSlice } from "@reduxjs/toolkit";
import { enqueueSnackbar } from 'notistack';

import { load, save, remove, setstars } from '../thunks/userAdminThunk'


export const userAdminSlice = createSlice({
    name: 'userAdmin',
    initialState:
    {
        items: [],
        selectedId: -1,
        selectedItem: null,
        openUserModal: false,
        openUserViewProfile: false,
    },
    reducers:
    {
        selectItem: (state, action) => {
            if (action.payload===null){
                state.selectedId = -1;
                state.selectedItem = null;
            }
            else{
                state.selectedId = action.payload;
                state.selectedItem = state.items.find( item => item.userId === action.payload );
            }
        },
        showUserModal: (state, action) => {
            state.openUserModal = action.payload;
        },
        showUserViewProfile: (state, action) => {
            state.openUserViewProfile = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(load.fulfilled, (state, action) => {
                if (action.payload?.code === '00') {
                    state.items = action.payload?.metadata;
                    state.selectedId = -1;
                    state.selectedItem = null;
                }
                else{
                    state.items = [];
                    state.selectedId = -1;
                    state.selectedItem = null;
                    enqueueSnackbar(action.payload?.message, { variant: 'error', persist: false });
                }
            })
            .addCase(save.fulfilled, (state, action) => {
                if (action.payload?.code === '00') {
                    if (action.payload?.metadata.action==='add')
                        state.items = [action.payload?.metadata, ...state.items];
                    else{
                        state.items = state.items.map(item => (
                            item.userId===action.payload?.metadata.userId
                                ? {
                                    ...item, 
                                    name: action.payload.metadata.name,
                                    email: action.payload.metadata.email,
                                    roleId: parseInt(action.payload.metadata.roleId),
                                    roleName: action.payload.metadata.roleName,
                                    isactive: action.payload.metadata.isactive.toLowerCase()==='true' ? true : false,
                                    active: action.payload.metadata.active,
                                }
                                : item
                        ))
                    }
                        
                    state.selectedId = action.payload?.metadata.userId;
                    state.selectedItem = action.payload?.metadata;
                    state.openUserModal = false;
                    enqueueSnackbar(action.payload?.message, { variant: 'success', persist: false });
                }
                else
                    enqueueSnackbar(action.payload?.message, { variant: 'error', persist: false });
            })
            .addCase(remove.fulfilled, (state, action) => {
                if (action.payload?.code === '00') {
                    state.items = state.items.filter(user => user.userId !== action.payload?.metadata.userId_deleted);

                    state.selectedId = -1;
                    state.selectedItem = null;
                    state.openUserModal = false;
                    enqueueSnackbar(action.payload?.message, { variant: 'success', persist: false });
                }
                else
                    enqueueSnackbar(action.payload?.message, { variant: 'error', persist: false });
            })
            .addCase(setstars.fulfilled, (state, action) => {
                if (action.payload?.code === '00') {
                    const userIdToUpdate = action.payload?.metadata.evaluatedUserId;

                    // 1. Encuentra el ítem (Immer lo encuentra dentro del Proxy)
                    const itemToUpdate = state.items.find(item => item.userId === userIdToUpdate);

                    // 2. Si lo encuentra, muta directamente el objeto dentro del estado
                    if (itemToUpdate) {
                        itemToUpdate.grade = action.payload.metadata.grade;
                        
                        // Puedes agregar el console.log aquí si quieres verificar el cambio *antes* del retorno del reducer
                        // console.log(itemToUpdate.grade); 
                    }
                    // state.items = state.items.map(user => user.userId===action.payload?.metadata.evaluatedUserId ? { ...user, grade: action.payload?.metadata.grade } : user)
                }
                else
                    enqueueSnackbar(action.payload?.message, { variant: 'error', persist: false });
            })
    }
})

export const { 
    selectItem,
    showUserModal,
    showUserViewProfile
} = userAdminSlice.actions;